// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___c-a1","question":"styles_question__1ViUY","inputVisibleButton":"styles_inputVisibleButton__2Kc1h","note":"styles_note__uNUwP"};